import React from 'react';
import {MdTextField, MdCheckbox} from 'core/components/fields/fields';
import {FieldText, FormProps, ClosedContentProps, lovLabel} from 'core/form/formUtils';
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import {observer} from "mobx-react";
import {createForm} from 'core/form/createForm';
import {Task} from "core/event/eventDomain";
import {grey400} from "material-ui/styles/colors";
import SvgIconProps = __MaterialUI.SvgIconProps;
import styled from "styled-components";





const CCDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

const TaskTypeSpan = styled.span` 
    color: ${grey400}
`;

const TaskName = styled.h5`
    margin-top: 0;
    font-size: 22px;
    font-weight: bold;
`;


const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<Task>) => {
  let taskType = lovLabel(dataObject.taskType);

  return (
    <CCDiv>
      <TaskName>{dataObject.name} {(taskType !== dataObject.name) ? <TaskTypeSpan> ({taskType})</TaskTypeSpan> : null} </TaskName>

    </CCDiv>
  )
};

@createForm({
  formName: 'TaskForm',
  fields: [{
    name: 'name',
    validators: ['IsRequired']
  }
  ]
}, ClosedContent)
@observer
export default class TaskForm extends React.Component<FormProps<Task, Task>, undefined> {



  render() {

    let {dataObject, rootObject, entities, entity, formName} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {name}= fields;

    let openContent = (
      <div>

        {/*  1. row  */}
        <div className="row">
          <div className="xs col-xs-12">
            <MdTextField {...name.props} />
            <Validate field={name} value={name.props.value} />
          </div>
        </div>

      </div>
    );

    return (
        <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />} {...this.props} validate={this.props.validate} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/event/component/taskForm.tsx